import React, { FC } from 'react'

import { IconIconTickProps } from './IconIconTick.types'
import * as Styled from './styles/IconIconTick.style'

import { nonThemeableRules } from '../../ruleSet'

const IconIconTick: FC<IconIconTickProps> = ({
  size = nonThemeableRules.defaultSize as number as IconIconTickProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconIconTickProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 192 192' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none' fillRule='evenodd'>
          <circle cx='96' cy='96' fill='#FFF' r='95.5' stroke='#FFF' />
          <path
            d='M73.805 149.135A6.917 6.917 0 0 1 68.9 147.1l-30.865-30.864a6.936 6.936 0 0 1 0-9.814 6.936 6.936 0 0 1 9.813 0l25.958 25.957 70.348-70.346a6.936 6.936 0 0 1 9.813 0 6.936 6.936 0 0 1 0 9.813L78.713 147.1a6.917 6.917 0 0 1-4.907 2.034'
            fill='#428600'
          />
        </g>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconIconTick
